var map = {
	"./activity-log.svg": 707,
	"./analytics.svg": 7091,
	"./bank.svg": 3365,
	"./card.svg": 8325,
	"./finance-active.svg": 8611,
	"./finance.svg": 1529,
	"./idplaceholder.svg": 4136,
	"./kuleanBrand.svg": 2184,
	"./livephoto.svg": 6635,
	"./logout.svg": 5521,
	"./merchant.svg": 4768,
	"./overview-active.svg": 8807,
	"./overview.svg": 8708,
	"./product-category.svg": 1333,
	"./product-status.svg": 3957,
	"./promotion-active.svg": 486,
	"./promotions.svg": 6883,
	"./push-notification-active.svg": 7003,
	"./push-notification.svg": 5630,
	"./reconciliation-active.svg": 9174,
	"./reconciliation.svg": 5409,
	"./report-active.svg": 7504,
	"./report.svg": 9510,
	"./reverse-active.svg": 5252,
	"./reverse.svg": 3370,
	"./send.svg": 4987,
	"./shield.svg": 6493,
	"./sms.svg": 203,
	"./transactions-active.svg": 9866,
	"./transactions.svg": 3068,
	"./user-active.svg": 9082,
	"./user.svg": 127,
	"./users-active.svg": 418,
	"./users.svg": 7611,
	"./utilityBill.svg": 8783,
	"./van.svg": 8775,
	"./verified.svg": 2643,
	"./verifiedIcon-active.svg": 1480,
	"./verifiedIcon.svg": 3611,
	"./verifiedTick.svg": 7907,
	"./visa.svg": 7314,
	"./wallet-active.svg": 4644,
	"./wallet.svg": 6476
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7690;